import React from 'react';
import propTypes from 'prop-types';

export function LoginImage({ image = '' }) {
  return (
    <div className="white-label-logo">
      {image && <img src={image} alt="" />}
    </div>
  );
}

export function TwoFactorImage({ image = '' }) {
  return (
    <div className="two-factor-image">
      {image && <img src={image} alt="" />}
    </div>
  );
}



// eslint-disable-next-line react/require-default-props
LoginImage.propTypes = {
  image: propTypes.string,
};



// eslint-disable-next-line react/require-default-props
TwoFactorImage.propTypes = {
  image: propTypes.string,
};
